import bookingEndpoints from 'actions/booking-endpoints';
import {
  SHOPIFY_GET_CONNECTIONS,
  SHOPIFY_COMPLETE_CONNECTION,
  SHOPIFY_INIT_CONNECTION,
  SHOPIFY_GET_ORDERS,
  SHOPIFY_GET_DELIVERIES_QUOTES,
  SHOPIFY_UPDATE_CONFIGURATION_BASIC,
  SHOPIFY_UPDATE_CONFIGURATION_PICKUP_ADDRESS,
  SHOPIFY_UPDATE_CONFIGURATION_FINANCIAL_STATUS,
  SHOPIFY_CREATE_DELIVERIES,
} from './endpoint-constants';
import fetchUtil from '../common/utils/fetch';
import { ROUTES_V2_PATHS } from '../constants/route-constants';
import { APP_BASE_URL_PATH } from '../constants/app-constants';
import { buildHeaders } from './fetch-helper';
import { buildCredentials } from '../helper/session-helper';

export const getShopifyConnectionsEndpoint = request => {
  const { endpoints } = window.Grab.config;
  const { geAPI } = endpoints;
  const { countryCode } = request;

  const params = new URLSearchParams();
  params.set('request.countryCode', countryCode);

  return `${geAPI}${SHOPIFY_GET_CONNECTIONS}?${params.toString()}`;
};

export const getShopifyOrdersEndpoint = request => {
  const { endpoints } = window.Grab.config;
  const { geAPI } = endpoints;
  const params = new URLSearchParams();
  const { shop, countryCode, filter, forceRefresh } = request;
  params.set('request.countryCode', countryCode);
  params.set('request.shop', shop);
  if (forceRefresh === true) {
    params.set('request.forceRefresh', 'true');
  }
  if (filter && typeof filter === 'object') {
    Object.entries(filter).forEach(([k, v]) => {
      if (v) {
        params.set(`request.filter.${k}`, `${v}`);
      }
    });
  }
  return `${geAPI}${SHOPIFY_GET_ORDERS}?${params.toString()}`;
};

const initConnectionEndpoint = () => {
  const { endpoints } = window.Grab.config;
  const { geAPI } = endpoints;
  return `${geAPI}${SHOPIFY_INIT_CONNECTION}`;
};

const completeConnectionEndpoint = () => {
  const { endpoints } = window.Grab.config;
  const { geAPI } = endpoints;
  return `${geAPI}${SHOPIFY_COMPLETE_CONNECTION}`;
};

export const getShopifyOrders = (request, companyID) =>
  fetchUtil(getShopifyOrdersEndpoint(request), {
    method: 'GET',
    headers: buildHeaders(null, null, companyID, true),
    credentials: buildCredentials(),
  });

export const getShopifyDeliveriesQuotesEndpoint = request => {
  const { endpoints } = window.Grab.config;
  const { geAPI } = endpoints;
  return {
    body: JSON.stringify({
      request,
    }),
    url: `${geAPI}${SHOPIFY_GET_DELIVERIES_QUOTES}`,
  };
};

export const getShopifyDeliveriesQuotes = (request, companyID) => {
  const { url, body } = getShopifyDeliveriesQuotesEndpoint(request);
  return fetchUtil(url, {
    method: 'POST',
    body,
    headers: buildHeaders(null, null, companyID, true),
    credentials: buildCredentials(),
  });
};

export const getMSDOptimizedRoute = (payload, companyID) =>
  fetchUtil(bookingEndpoints.getV2QuoteEpt(), {
    headers: buildHeaders(null, null, companyID, true),
    credentials: buildCredentials(),
    body: JSON.stringify(payload),
    method: 'POST',
  });

export const initConnection = (
  shop,
  host,
  timestamp,
  hmac,
  skipHmac = false,
  skipDuplicationCheck = false,
) => {
  const { protocol, host: hostName } = window.location;
  // eslint-disable-next-line prettier/prettier
  const callbackURL = `${protocol}//${hostName}${APP_BASE_URL_PATH}${
    ROUTES_V2_PATHS.shopifyLanding
  }`;
  const request = {
    request: {
      shop,
      host,
      hmac,
      callbackURL,
      skipHmac,
      skipDuplicationCheck,
      timestamp,
    },
  };
  const body = JSON.stringify(request);
  return fetchUtil(initConnectionEndpoint(), {
    method: 'POST',
    body,
  });
};

export const completeConnection = (
  code,
  shop,
  host,
  timestamp,
  hmac,
  state,
  companyID,
  countryCode,
) => {
  const request = {
    request: {
      code,
      shop,
      host,
      state,
      hmac,
      timestamp,
      countryCode,
    },
  };
  const body = JSON.stringify(request);
  return fetchUtil(completeConnectionEndpoint(), {
    method: 'POST',
    body,
    headers: buildHeaders(null, null, companyID, true),
    credentials: buildCredentials(),
  });
};

export const updateShopifyConfigurationBasic = (requestParams, companyID) => {
  const { endpoints } = window.Grab.config;
  const { geAPI } = endpoints;
  const { shop, productCategoryID, defaultItemWeight } = requestParams;
  return fetchUtil(`${geAPI}${SHOPIFY_UPDATE_CONFIGURATION_BASIC}`, {
    method: 'POST',
    headers: buildHeaders(null, null, companyID, true),
    credentials: buildCredentials(),
    body: JSON.stringify({
      request: {
        shop,
        productCategoryID,
        defaultItemWeight,
      },
    }),
  });
};

export const updateShopifyConfigurationPickUpAddress = (
  requestParams,
  companyID,
) => {
  const { endpoints } = window.Grab.config;
  const { geAPI } = endpoints;
  const { shop, shopifyPickUpAddress } = requestParams;
  return fetchUtil(`${geAPI}${SHOPIFY_UPDATE_CONFIGURATION_PICKUP_ADDRESS}`, {
    method: 'POST',
    headers: buildHeaders(null, null, companyID, true),
    credentials: buildCredentials(),
    body: JSON.stringify({
      request: {
        shop,
        shopifyPickUpAddress,
      },
    }),
  });
};

export const updateShopifyConfigurationFinancialStatus = (
  requestParams,
  companyID,
) => {
  const { endpoints } = window.Grab.config;
  const { geAPI } = endpoints;
  const { shop, countryCode, financialStatuses } = requestParams;
  return fetchUtil(`${geAPI}${SHOPIFY_UPDATE_CONFIGURATION_FINANCIAL_STATUS}`, {
    method: 'POST',
    headers: buildHeaders(null, null, companyID, true),
    credentials: buildCredentials(),
    body: JSON.stringify({
      request: {
        shop,
        countryCode,
        financialStatuses,
      },
    }),
  });
};

export const getCreateShopifyDeliveriesEpt = () => {
  const { endpoints } = window.Grab.config;
  const { geAPI } = endpoints;
  return `${geAPI}${SHOPIFY_CREATE_DELIVERIES}`;
};
